import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CarouselSlide from './CarouselSlide'
import Carousel from './Carousel'
import PromoBanners from '../promoBanners/PromoBanners'
import { prismicHelpers } from '../../helpers'

/* doc
---
title: Hero Carousel
name: herocarousel
category: Javascript - Components
---

The Hero Carousel is a React component that displays a carousel and (optionally)
side banners that are typically pulled from Prismic. Styles support 0-6 side banners,
although any more than 4 can look really small on certain devices.

```html_example
  <%= react_component 'HeroCarousel', { data: prismic_data } %>
```

TODO: Figure out how to display examples properly in styleguide.
*/
class HeroCarousel extends Component {
  constructor(props) {
    super(props)

    this.renderSlides = this.renderSlides.bind(this)
  }

  /**
  * Render individual carousel slides.
  */
  renderSlides(slides) {
    if (!slides) {
      return false
    }

    return slides
      .map((slide, idx) => {
        slide.promoId = this.props.data.uid
        slide.promoName = this.props.data.promoName

        // Start index at 1 since it is used for analytics stuff (more muggle friendly)
        return <CarouselSlide slide={slide} key={idx} index={idx + 1} />
      })
  }

  render() {
    // Make sure we have the right data.
    if ((!this.props.data.slides && !this.props.data.banners) || !prismicHelpers.userHasPermission(this.props.data)) {
      return false
    }

    // Filter slides and banners to only show ones the user can see.
    const slides = this.props.data.slides
      .filter(slide => prismicHelpers.userHasPermission(slide))


    const banners = !this.props.data.banners ? [] : this.props.data.banners
      .filter(banner => prismicHelpers.userHasPermission(banner))


    const carouselProps = {
      autoplay: slides.length > 1,
      autoplayTimeout: 10000,
      autoplayHoverPause: false, // BUG in hover pause, switch to `true` once fixed: https://github.com/OwlCarousel2/OwlCarousel2/issues/1860
      center: false,
      dots: false,
      items: 1,
      loop: slides.length > 1,
      nav: slides.length > 1,
      lazyLoad: true,
      mouseDrag: slides.length > 1,
      touchDrag: slides.length > 1,
      pullDrag: slides.length > 1,
    }


    const promoBannersData = {
      banners,
      uid: this.props.data.uid,
      promoName: this.props.data.promoName,
      loginPermission: 'both',
      platinumPermission: 'both',
      plusPermission: 'both',
      showDesktop: 'yes',
      showMobile: 'yes',
      showTablet: 'yes',
      bannerSpacing: this.props.data.bannerSpacing,
    }


    const viewableClass = prismicHelpers.formatViewClasses(this.props.data)


    const horizontalMarginClass = prismicHelpers.getSpacingClass(this.props.data, 'horizontalMargin')


    const verticalMarginClass = prismicHelpers.getSpacingClass(this.props.data, 'verticalMargin')


    const bannerSpacingClass = prismicHelpers.getSpacingClass(this.props.data, 'bannerSpacing')


    const ratioClass = this.props.data.slides && this.props.data.slides[0].type ? `is-${this.props.data.slides[0].type}` : 'is-2x1'

    // If the user doesn't have access to any slides or banners just return false.
    if (!slides.length && !banners.length) {
      return false
    }

    return (
      <div className={`hero-carousel has-${banners.length}-banners ${ratioClass} ${viewableClass} ${horizontalMarginClass} ${verticalMarginClass} ${bannerSpacingClass}`}>
        <Carousel {...carouselProps}>
          { this.renderSlides(slides) }
        </Carousel>
        <PromoBanners data={promoBannersData} type="carousel" />
      </div>
    )
  }
}

HeroCarousel.propTypes = {
  data: PropTypes.object.isRequired,
}

export default HeroCarousel
